import { defaultsDeep } from 'lodash';

export const overrideProps = (props, overrides) => {
    return defaultsDeep({ ...overrides }, props);
};
